export default __webpack_public_path__ + "static/media/gallery_02.93e69024.jpg";